
export const Theme = {
  content: [
    'relative rounded-lg border border-gray-200 bg-white overflow-hidden shadow-md',
    'dark:border-gray-700 dark:bg-gray-800'
  ]
};
